import TestResponseItemList from './TestResponseItemList';
import { TestResponseItemListProps, TestResponseItemListValueProps } from './types';

export type { TestResponseItemListProps, TestResponseItemListValueProps };
export default TestResponseItemList;
